import { RootState } from '@/store/main';

export const selectPasscodeList = (state: RootState) => state.passcodeLists.passcodeList;
export const selectPasscodeLists = (state: RootState) => state.passcodeLists.passcodeLists;
export const selectLoadingPasscodeLists = (state: RootState) => state.passcodeLists.loadingPasscodeLists;
export const selectPasscodeListMembers = (state: RootState) => state.passcodeLists.passcodeListMembers;
export const selectPasscodeListMemberCount = (state: RootState) => state.passcodeLists.passcodeListMemberCount;
export const selectAssociatedEvents = (state: RootState) => state.passcodeLists.passcodeListAssociatedEvents;
export const selectAssociatedEventsDetails = (state: RootState) =>
  state.passcodeLists.passcodeListAssociatedEventsDetails;
export const selectMemberPasscodeLists = (state: RootState) => state.passcodeLists.memberPasscodeLists;
export const selectMemberPasscodeListsLoading = (state: RootState) => state.passcodeLists.loadingMemberPasscodeLists;
export const selectMagicLinkRegistrationsPasscodeList = (state: RootState) =>
  state.passcodeLists.magicLinkRegistrationsPasscodeList;
export const selectPasscodeListMembersLoading = (state: RootState) => state.passcodeLists.loadingPasscodeListMembers;
